<template>

</template>

<script>

import auth from '../../../lib/auth';
import constants from '../../../lib/constants';
export default {
  data(){
      return{
        mid:"123",
        store_id:"",
        cb_url:encodeURIComponent(location.href),
        card_num:"",
        cust_mobile:"",
        card_bind_vcode:"",
        err_msg:"",
        time: 60, // 发送验证码倒计时
        sendMsgDisabled: false,
      }
  },
  mounted(){
      this.mid = getQueryString("mid");
      this.store_id = getQueryString("store_id") || "";
      var r_code = getQueryString("r_code");
      var r_data = getQueryString("r_data");
      if(!r_code && !r_data){
        window.location.href= constants.API_HOST + '/api/weixin/login.htm?mid='+this.mid+'&cb_url='+this.cb_url+'&store_id='+this.store_id;
      }else{
          if(r_code == 200){
            console.log(r_data,233);
//            r_data = JSON.parse(r_data);
//            var tokens = r_data.loginOutputVO.access_token;
            var tokens = r_data;
            localStorage.setItem("tokens",tokens);
            this.getVip();
          }else{
              location.href='/main.html?mid= '+this.mid+'&store_id='+this.store_id+'#/gowhere';
          }

      }
  },
  methods: {

    getVip(){
      this.$http.post(constants.API_HOST + constants.API_VIEW_CARD, {
      }).then((result) => {
        let data = result.data;
        if (data.code === "200") {
              location.href='/main.html?mid='+this.mid+'&store_id='+this.store_id+'#/card_qrcode'
        }else {
          location.href='/main.html?mid='+this.mid+'&store_id='+this.store_id+'#/card_choose'
        }
      }, (error) => {
        error.data && this.$alert(error.data);
      });
    },
  }

}

function getQueryString(key){
  var reg = new RegExp("(^|&)"+key+"=([^&]*)(&|#|$)");
  var result = window.location.search.substr(1).match(reg);
  return result?decodeURIComponent(result[2]):null;
}
</script>

<style>

  body,html{
    height:100%;
  }
  html {
    font-size:90px!important
  }
  @media only screen and (min-width:319px) {
    html {
      font-size:100px!important
    }
  }@media only screen and (min-width:370px) {
    html {
      font-size:117px!important
    }
  }@media only screen and (min-width:414px) {
    html {
      font-size:129px!important
    }
  }
  @media only screen and (min-width:639px) {
    html {
      font-size:200px!important
    }
  }

  .button-one span{
    background-image: url(http://style.cdn.juhaomai.net/style/images/site/sp/blue/online_newcard_vip.png);
    background-repeat: no-repeat;
    background-size: cover;
    width: 13.5px;
    height: 8.5px;
    display: inline-block;
  }


  .button-two span{
    background-image: url(http://style.cdn.juhaomai.net/style/images/site/sp/blue/online_newcard_phone.png);
    background-repeat: no-repeat;
    background-size: cover;
    width: 10px;
    height: 13.5px;
    display: inline-block;
  }
  .button-three span{
    background-image: url(http://style.cdn.juhaomai.net/style/images/site/sp/blue/online_newcard_shilden.png);
    background-repeat: no-repeat;
    background-size: cover;
    width: 10px;
    height: 12px;
    display: inline-block;
  }



  .success img{
    width: 247px;
  }

  .success-text p{
    margin-bottom: 3%;
  }
  .success-text input{
    height: 35px;
    border: 0px;
    background: #50A200;
    color: #fff;
    font-size: 18px;
    letter-spacing: 3px;
    margin-top: 2%;
    width:70%;
  }

  .fail img{
    width: 247px;
  }

  .fail-text p{
    margin-bottom: 3%;
  }
  .fail-text input{
    height: 35px;
    border: 0px;
    background: #50A200;
    color: #fff;
    font-size: 18px;
    letter-spacing: 3px;
    margin-top: 2%;
    width:70%;
  }

  .again img{
    width: 247px;
  }

  .again-text .pass{
    background:#356500 ;
    margin-top: 10px;
    letter-spacing: 3px;
  }
  .again input{
    height: 35px;
    border: 0px;
    background: #50A200;
    color: #fff;
    font-size: 18px;
    letter-spacing: 1px;
    margin-top: 2%;
    width: 70%;
  }

</style>



// WEBPACK FOOTER //
// Main.vue?dd8f4104